export enum OcpsPolicy {
    Contact,
    Content,
    Feedback,
    NpsSurvey,
    OutlookRecommendation,
    ScreenShot,
}
